<template>
  <va-create-layout>
    <OrderRequestItem-form :title="title" :item="item"></OrderRequestItem-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
